<template>
    <sa-page-layout :btnAnnullaVisible="false" :btnBackVisible="true" :btnSaveVisible="true" :data="jsonData" @aftersave="onAfterSave" :showModalLoading="showModalLoading" :pathResource="pathResource" :linkback="linkback" class="sa-no-space">
        <template slot="table-body">
            <contabilita-soggetto-edit-component ref="cmpContabilitaSoggettoEdit" @update="onUpdateJsonData"></contabilita-soggetto-edit-component>
        </template>
        <contabilita-soggetto-view-component ref="cmpContabilitaSoggettoView" :jsonData="jsonData"></contabilita-soggetto-view-component>
    </sa-page-layout>
</template>
<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import ContabilitaSoggettoEditComponent from "../components/ContabilitaSoggettoEditComponent.vue";
import ContabilitaSoggettoViewComponent from "../components/ContabilitaSoggettoViewComponent.vue";

export default {
    components: { SaPageLayout, ContabilitaSoggettoEditComponent, ContabilitaSoggettoViewComponent },
    data() {
        return {
            showModalLoading: false,
            pathResource: "/contabilitasoggetti",
            linkback: "/contabilita/soggetto",
            jsonData: {},
        };
    },
    mounted() {
        let me = this;
        this.$nextTick(() => {
            me.id = this.$route.params.id;
            if (me.id && me.id !== "-1") {
                me.$refs.cmpContabilitaSoggettoEdit.init(me.id);
            }
        });
    },
    methods: {
        onUpdateJsonData(data) {
            let me = this;
            me.jsonData = data;
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onAfterSave() {
            // let me = this;
            // me.id = me.$route.params.id;
            // if (me.id === "-1") {
            //     me.$router.replace(me.linkback).catch((err) => {
            //         console.log(err);
            //     });
            // }
        },
    },
};
</script>

<style></style>
